module.exports = __webpack_public_path__ + "img/Frame 1143four1.eb85d65d.png";